import { NgxIndexedDBService } from "ngx-indexed-db";
import { catchError, firstValueFrom, from, map, Observable, of, switchMap } from "rxjs";

import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DbService {
  private readonly expirationTime = 24 * 60 * 10 * 1000; // tous les jours

  constructor(private dbService: NgxIndexedDBService) {}

  /**
   * Sauvegarde l'avatar avec un timestamp pour gérer son expiration.
   */
  async saveAvatar(item: any): Promise<{ id: string; value: any; timestamp: number }> {
    const data = {
      id: "currentAvatar",
      value: item,
      timestamp: Date.now(),
    };

    try {
      return await firstValueFrom(
        this.dbService.clear("dynamicStore").pipe(
          switchMap(() => this.dbService.add("dynamicStore", data)),
          catchError(() => of(null)),
        ),
      );
    } catch {
      return null;
    }
  }

  /**
   * Récupère l'avatar s'il est valide (non expiré).
   */
  getAvatar(): Observable<any> {
    const now = Date.now();

    return this.dbService.getByKey("dynamicStore", "currentAvatar").pipe(
      map((data: any) => {
        if (data && data.timestamp && now - data.timestamp < this.expirationTime) {
          return data.value;
        }
        return null;
      }),
      catchError(() => of(null)),
    );
  }

  clearAll(): Observable<void> {
    return from(
      new Promise<void>((resolve, reject) => {
        const deleteRequest = indexedDB.deleteDatabase("evaDb");
        deleteRequest.onsuccess = () => resolve();
        deleteRequest.onerror = (event) => reject(event);
        deleteRequest.onblocked = () => reject();
      }),
    );
  }
}
